var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCA4F"
    },
    d: "M256.002,0c141.384,0,255.999,114.615,255.999,255.999S397.386,512,256.002,512 C114.615,512,0.001,397.385,0.001,255.999C0.001,114.615,114.615,0,256.002,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M180.777,397.956L156.4,502.861c-1.449,6.332-7.757,10.29-14.089,8.841 c-6.335-1.449-10.29-7.759-8.841-14.089l27.27-117.364c6.546,6.438,13.245,12.349,20.035,17.709L180.777,397.956z M239.721,429.757 L239.721,429.757l12.645,45.288c1.729,6.255-1.94,12.729-8.195,14.457c-6.255,1.729-12.729-1.942-14.457-8.195l-17.54-62.829 c9.227,4.824,18.457,8.606,27.55,11.28H239.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB1"
    },
    d: "M306.442,181.345c60.06,90.298,66.143,198.311,13.589,241.255s-143.849,4.555-203.909-85.742 c-60.06-90.3-66.146-198.311-13.589-241.255c52.553-42.944,143.849-4.553,203.909,85.745V181.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M307.65,179.724c58.59,88.884,64.527,195.204,13.256,237.476 c-51.269,42.271-140.328,4.485-198.917-84.4c-58.59-88.882-64.525-195.202-13.256-237.474s140.33-4.482,198.917,84.4V179.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.484,184.141c48.057,75.047,52.961,164.5,10.958,199.804s-115.012,3.089-163.064-71.955 c-48.057-75.047-52.961-164.5-10.958-199.804c42.002-35.306,115.012-3.091,163.067,71.955H299.484z M281.086,206.981 L281.086,206.981c-23.881-37.299-60.17-53.313-81.046-35.763c-20.878,17.546-18.441,62.007,5.446,99.309 c23.881,37.297,60.173,53.311,81.046,35.763C307.41,288.741,304.974,244.28,281.086,206.981z M276.882,213.963L276.882,213.963 c-17.683-27.618-44.553-39.473-60.012-26.482c-15.456,12.993-13.652,45.916,4.033,73.534 c17.683,27.618,44.553,39.476,60.012,26.482C296.37,274.504,294.567,241.581,276.882,213.963z M289.886,194.367L289.886,194.367 c-34.585-54.014-87.136-77.203-117.369-51.792c-30.231,25.411-26.699,89.797,7.887,143.812 c34.588,54.014,87.138,77.201,117.371,51.792C328.006,312.767,324.473,248.381,289.886,194.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.711,227.023c7.549,11.792,8.321,25.848,1.722,31.393c-6.599,5.547-18.071,0.485-25.62-11.307 s-8.323-25.845-1.724-31.393C243.69,210.169,255.159,215.231,262.711,227.023z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E7886"
    },
    d: "M277.611,213.69L489.758,90.187c3.466-2.017,7.953-0.833,9.97,2.633v0.002 c2.017,3.464,0.833,7.953-2.633,9.97l-212.149,123.5c-3.466,2.02-7.953,0.833-9.97-2.63l-0.002-0.002 c-2.017-3.466-0.831-7.953,2.635-9.968L277.611,213.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M410.357,153.284l88.154-51.32l13.489,23.173l-69.72,40.589L410.357,153.284z M403.019,140.681 L403.019,140.681l88.157-51.32l-13.492-23.173l-69.72,40.589l-4.943,33.902L403.019,140.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M253.521,236.149l19.628-41.859l26.465,45.46L253.521,236.149z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.dcaf39bca86f18a13a1ba55c128667b9.svg";
export { ForwardRef as ReactComponent };